export default "__VITE_ASSET__582e2159__"